import { ISignerData } from '../../completeChart/store/completeChart.types'
import { IAgencyNumbers } from '../../configurations/store/configurations.types'
import { IPCRCrewMemberList } from '../../crew/store/crew.types'
import { ISourceInfo } from '../../pcr/store/pcr.types'

export enum upgradeStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
}

export interface IHomeFilterState {
  showClearFiltersButton: boolean
  incompleteFilterOn: boolean
  completeFilterOn: boolean
  needsReviewFilterOn: boolean
}

export interface IPcrSummary {
  agencyName: string
  agencyNumber: IAgencyNumbers
  callNature: string
  createdBy: string
  createDateTime: string
  crew: IPCRCrewMemberList
  date: string
  patientName: string
  pcrId: string
  prid: string | null
  pickupLocation: string
  serviceId: string
  status: string
  time: string
  timeZoneOffset: string
  unit: string
  base: string
  version: string
  isChartLockedIn: number
  lastAutoUploadDateTime: string | null
  signerDetails: ISignerData
  sourceInfo: ISourceInfo
}

export type IPcrSummaries = Array<IPcrSummary>

export interface IHomeState {
  pcrDocs: IPcrSummaries
  pcrId: string | undefined
  pcr: IPcrSummary | null
  filteredPCRDocs: IPcrSummaries
  filter: IHomeFilterState
  upgradeStatus: upgradeStatus
  addressTypeSelected: number
  hideComponent: boolean
  isPCROpening: boolean
  isPCRClosing: boolean
  isPCRError: boolean
}

export interface IHomeAction extends IHomeState {
  type: string
  docs: []
  showClearFiltersButton: boolean
}
